import "../components/sections/selected-filters-section/selected-filters-section"

import "./main-header"
import "../components/layout-banner/layout-banner"

(async () => {
    await import("./main")
})()

async function loadLazyload() {
    if (document.querySelectorAll("[data-src], [data-bg]").length) {
        const {lazyLoading} = await import("./lazyload/lazyload-init")
        window.lazyloading = lazyLoading // add lazyloading to global window object
    }
}
loadLazyload()

async function replaceAfterLoadFromUrl() {
    if (document.querySelectorAll("[data-replace-after-load-from-url]").length) {
        const {replaceAfterLoadFromUrl} = await import("./lazyload/replace-after-load")
        window.replaceAfterLoadFromUrl = replaceAfterLoadFromUrl // add lazyloading to global window object
    }
}
document.addEventListener('DOMContentLoaded', () => {
    replaceAfterLoadFromUrl()
});

async function loadHotelyUi() {
    if (document.querySelectorAll("[data-hp-pop], [data-hp-suggest], [data-hpd-gal], [data-hpr-index], [data-hpd-esearch-url], [data-hpd-esearch-toggle], [data-hp-count], [data-hpt-gallery], [data-hpd-contacts-url], [data-hph-form]").length) {
        await import("./hotely/hotely-ui")
    }
}
loadHotelyUi()


async function loadDatepicker() {
    if (document.querySelectorAll(".--datepicker").length) {
        await import("./datepicker/datepicker-init")
    }
}
loadDatepicker()


async function loadFancybox() {
    if (document.querySelectorAll("[data-fancybox]").length) {
        await import("./fancybox/fancybox")
    }
}
loadFancybox()

async function loadFormValidation() {
    if (document.querySelectorAll('[data-validate="jquery"]').length) {
        await import("./form-validation");
    }
}
loadFormValidation()

async function loadMainMap() {
    if (document.getElementById('map') !== null) {
        await import("./main-map");
    }
}
loadMainMap()

async function loadMainInlineMap() {
    if (document.getElementById('map_inline') !== null) {
        await import("./main-inline-map");
    }
}
loadMainInlineMap()

async function loadAutoComplete() {
    if (document.querySelectorAll('input[type="search"][data-autocomplete]') !== null) {
        await import("./autocomplete");
    }
}
loadAutoComplete()

async function loadCharts() {
    if (document.querySelectorAll(".i-broker-list-chart, .i-broker-chart, .i-review-chart").length) {
        await import("./chart");
    }
}
loadCharts()

async function loadSplide() {
    // if (document.querySelectorAll(".s-posts-slide, .s-agents-slider").length) {
    if (document.querySelectorAll(".splide").length) {
        await import("./splide");
    }
}
loadSplide()

async function loadChoices() {
    if (document.querySelectorAll(".select.i-pagination__select, select.i-pagination__select, .dropdown__wrapper").length) {
        await import("./choices");
    }
}
loadChoices()

async function loadSwiper() {
    if (document.querySelectorAll(".s-broker-review-slide, .s-dev-project-slide, .s-estates-slide, .s-re-agency-detail-branches, .swiper").length) {
        await import("./swiper");
    }
}
loadSwiper()

async function loadCtaButton() {
    if (document.querySelectorAll('.cta-button').length) {
        await import("./cta-button");
    }
}
loadCtaButton()
